import { Block } from 'webiq.boilerplate'

export default class CheckoutField extends Block {
	static title = 'checkout-field'

	init() {
        if (this.hasModifier('address')) {
            this.element.addEventListener('sl-input', () => {
                this.replaceText()       
            })
        }
	}

    replaceText() {
        const newValue = this.cleanString(this.element.value)
        this.element.value = newValue.cleaned
        if (newValue.replaced) {
            window.eventEmitter.emit('message:html')
        }
    }

    cleanString(str) {
        let replaced = false;
        const cleaned = str.replace(
          /[^\p{Script=Latin}\p{Number}\p{Punctuation}\p{Separator}]/gu,
          match => {
            replaced = true; // mark that something got removed
            return '';
          }
        );
        return { cleaned, replaced };
    }
}
